export const ru = {
    month: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь'
    ],
    days: [
        'Понедельник',
        'Вторник',
        'Среда',
        'Четверг',
        'Пятница',
        'Суббота',
        'Воскресенье'
    ],
    time: 'Время',
    moment: { 
        week: {
            dow: 1, 
            doy: 4
        }
    },
    actions: {
        close: 'Закрыть'
    }
}